module.exports = __webpack_public_path__ + "static/media/collectibles_art.72c375f2.png";